export enum Language {
  English = 'EN'
}

export const normalizeLanguage = (language: Language): Language => {
  return language && Object.values(Language).indexOf(language) >= 0 ? language : Language.English;
};
